import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import {MenuControlsContainer} from 'mui-tiptap';

const StyledEditorMenuControlsContainer = styled(MenuControlsContainer)`
  ${ComponentStyles}
`;

StyledEditorMenuControlsContainer.propTypes = {
  theme: PropTypes.object
};

export default StyledEditorMenuControlsContainer;
